import Api from "@/services/api";
import {removeEmptyParams} from "@utils";

export default {
    findAll(filter) {
        return Api().get("/uers", {params: removeEmptyParams(filter)}).then(res => {
            res.data.forEach(e => this.formatRes(e));
            return res.data;
        });
    },
    findAllCurrent(filter) {
        return Api().get("/uers/current", {params: removeEmptyParams(filter)}).then(res => {
            res.data.forEach(e => this.formatRes(e));
            return res.data;
        });
    },
    findAllByYear(year) {
        return Api().get("/uers/year/" + year).then(res => {
            res.data.forEach(e => this.formatRes(e));
            return res.data;
        });
    },
    findById(id) {
        return Api().get("/uer/" + id).then(res => this.formatRes(res.data));
    },
    create(uer) {
        return Api().post("/uer", uer).then(res => this.formatRes(res.data));
    },
    update(uer) {
        return Api().put("/uer/" + uer.id, uer).then(res => this.formatRes(res.data));
    },
    delete(uer) {
        return Api().delete("/uer/" + uer.id).then(() => uer);
    },
    formatRes(e) {
        return e;
    },
}